import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'core/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  readonly #authService = inject(AuthService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userToken: string = this.#authService.userToken;
    const isApiUrl: boolean = request.url.startsWith(environment.apiUrl);

    if (userToken && isApiUrl) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${userToken}` }
      });
    }

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (isApiUrl && this.#isUnauthorizedError(error)) {
          this.#authService.logOut();
        }

        return throwError(() => error);
      })
    );
  }

  #isUnauthorizedError(error: unknown): boolean {
    if (!error || typeof error !== 'object') {
      return false;
    }

    const httpError = error as { code?: unknown; status?: unknown };
    return httpError.code === 401 || httpError.status === 401;
  }
}
